import { useNavigate } from "react-router-dom";
import "./Content.css";

// const awardsData = [
//   { sno: 1, category: "D1. MHW Star District", club: "DISTRICT 3232 F1", md: "3232" },
//   { sno: 2, category: "D1. MHW Star District", club: "DISTRICT 3233 G1", md: "3233" },
//   { sno: 3, category: "D2. MHW Quantitative Impact Leader", club: "DISTRICT 317 B", md: "317" },
//   // 👉 Continue ALL rows SAME as PDF (no skipping)
// ];


// const awardsData = [
//   { sno: 1, category: "D1. MHW Star District", club: "DISTRICT 3232 F1", md: "3232" },
//   { sno: 2, category: "D1. MHW Star District", club: "DISTRICT 3233 G1", md: "3233" },

//   { sno: 3, category: "D2. MHW Quantitative Impact Leader", club: "DISTRICT 317 B", md: "317" },
//   { sno: 4, category: "D2. MHW Quantitative Impact Leader", club: "DISTRICT 3232 F1", md: "3232" },

//   { sno: 5, category: "D3. MHW Highest Lion Participation Star District", club: "DISTRICT 317 B", md: "317" },
//   { sno: 6, category: "D3. MHW Highest Lion Participation Star District", club: "DISTRICT 320 D", md: "320" },

//   { sno: 7, category: "D4. MHW Collaboration Star District", club: "DISTRICT 3234D1", md: "3234" },
//   { sno: 8, category: "D4. MHW Collaboration Star District", club: "DISTRICT 3232F1", md: "3232" },

//   { sno: 9, category: "C5. MHW Innovation Champion", club: "JALPAIGURI SEVA", md: "322" },
//   { sno: 10, category: "C5. MHW Innovation Champion", club: "ALIBAG", md: "3231" },
//   { sno: 11, category: "C5. MHW Innovation Champion", club: "PALAKOL FEMINA", md: "316" },
//   { sno: 12, category: "C5. MHW Innovation Champion", club: "DIMAPUR JAPFU", md: "322" },
//   { sno: 13, category: "C5. MHW Innovation Champion", club: "MANIPAL", md: "317" },

//   { sno: 14, category: "C6. MHW Outreach Hero", club: "BHOPAL SAROVAR", md: "3233" },
//   { sno: 15, category: "C6. MHW Outreach Hero", club: "PARASIA CHANDAMETTA", md: "3233" },
//   { sno: 16, category: "C6. MHW Outreach Hero", club: "MASUR", md: "3234" },
//   { sno: 17, category: "C6. MHW Outreach Hero", club: "JALPAIGURI SEVA", md: "322" },
//   { sno: 18, category: "C6. MHW Outreach Hero", club: "IMPHAL", md: "322" },

//   { sno: 19, category: "C7. MHW Youth Wellness Leader", club: "NEW BOMBAY AIROLI", md: "3231" },
//   { sno: 20, category: "C7. MHW Youth Wellness Leader", club: "THANE URBAN", md: "3231" },
//   { sno: 21, category: "C7. MHW Youth Wellness Leader", club: "BHOPAL SAROVAR", md: "3233" },
//   { sno: 22, category: "C7. MHW Youth Wellness Leader", club: "SATNA", md: "3233" },
//   { sno: 23, category: "C7. MHW Youth Wellness Leader", club: "NAGAON GREATER", md: "322" },

//   { sno: 24, category: "C8. MHW Documentation Excellence Award", club: "KARAD NAKSHATRA", md: "3234" },
//   { sno: 25, category: "C8. MHW Documentation Excellence Award", club: "BELMAN", md: "317" },
//   { sno: 26, category: "C8. MHW Documentation Excellence Award", club: "BOMBAY MULUND", md: "3231" },
//   { sno: 27, category: "C8. MHW Documentation Excellence Award", club: "HYDERABAD CAPITAL", md: "320" },
//   { sno: 28, category: "C8. MHW Documentation Excellence Award", club: "SILIGURI GREATER FAMINA", md: "322" },

//   { sno: 29, category: "C9. MHW Silver Wellness Award", club: "PARASIA-CHANDAMETTA", md: "3233" },
//   { sno: 30, category: "C9. MHW Silver Wellness Award", club: "BELMAN", md: "317" },
//   { sno: 31, category: "C9. MHW Silver Wellness Award", club: "BILASPUR PRIDE", md: "3233" },
//   { sno: 32, category: "C9. MHW Silver Wellness Award", club: "BHOPAL SAROVAR", md: "3233" },
//   { sno: 33, category: "C9. MHW Silver Wellness Award", club: "SATNA", md: "3233" },

//   { sno: 34, category: "C10. MHW Workplace Wellness Star", club: "HYDERABAD JUBILEE HILLS", md: "320" },
//   { sno: 35, category: "C10. MHW Workplace Wellness Star", club: "SATNA", md: "3233" },
//   { sno: 36, category: "C10. MHW Workplace Wellness Star", club: "BHOPAL MAJESTIC", md: "3233" },
//   { sno: 37, category: "C10. MHW Workplace Wellness Star", club: "BANDERDEWA", md: "322" },
//   { sno: 38, category: "C10. MHW Workplace Wellness Star", club: "IMPHAL", md: "322" },

//   { sno: 39, category: "C11. MHW Digital Reach Champion", club: "KARAD NAKSHATRA", md: "3234" },
//   { sno: 40, category: "C11. MHW Digital Reach Champion", club: "PARASIA-CHANDAMETTA", md: "3233" },
//   { sno: 41, category: "C11. MHW Digital Reach Champion", club: "SILIGURI FEMINA", md: "322" },
//   { sno: 42, category: "C11. MHW Digital Reach Champion", club: "SILCHAR ANANTA", md: "322" },
//   { sno: 43, category: "C11. MHW Digital Reach Champion", club: "GUWAHATI ARPAN", md: "322" },

//   { sno: 44, category: "C12. MHW Little Minds Nurturer", club: "AKKALKOT", md: "3234" },
//   { sno: 45, category: "C12. MHW Little Minds Nurturer", club: "PANVEL SARGAM", md: "3231" },
//   { sno: 46, category: "C12. MHW Little Minds Nurturer", club: "SATNA", md: "3233" },
//   { sno: 47, category: "C12. MHW Little Minds Nurturer", club: "HYD. JUBILEE HILLS", md: "320" },
//   { sno: 48, category: "C12. MHW Little Minds Nurturer", club: "RAIGANJ UNITY", md: "322" },

//   { sno: 49, category: "C13. MWH Tender Hearts Award", club: "SATNA", md: "3233" },
//   { sno: 50, category: "C13. MWH Tender Hearts Award", club: "KARAD NAKSHATRA", md: "3234" },
//   { sno: 51, category: "C13. MWH Tender Hearts Award", club: "JOHAT", md: "322" },
//   { sno: 52, category: "C13. MWH Tender Hearts Award", club: "MANIPAL", md: "317" },
//   { sno: 53, category: "C13. MWH Tender Hearts Award", club: "RAIGANJ UNITY", md: "322" },

//   { sno: 54, category: "C14. MHW Shakti Samman", club: "BILASPUR PRIDE", md: "3233" },
//   { sno: 55, category: "C14. MHW Shakti Samman", club: "IMPHAL EXELLENCE", md: "322" },
//   { sno: 56, category: "C14. MHW Shakti Samman", club: "PANDHARPUR DREAM", md: "3234" },
//   { sno: 57, category: "C14. MHW Shakti Samman", club: "ALIBAG DIAMOND", md: "3231" },
//   { sno: 58, category: "C14. MHW Shakti Samman", club: "HYDERABAD JUBILEEHILLS", md: "320" },

//   { sno: 59, category: "C15. MHW Golden Years Guardian Award", club: "IMPHAL", md: "322" },
//   { sno: 60, category: "C15. MHW Golden Years Guardian Award", club: "THANE URBAN", md: "3231" },
//   { sno: 61, category: "C15. MHW Golden Years Guardian Award", club: "ALIBAG", md: "3231" },
//   { sno: 62, category: "C15. MHW Golden Years Guardian Award", club: "HYDERABAD CAPITAL", md: "320" },
//   { sno: 63, category: "C15. MHW Golden Years Guardian Award", club: "GUWAHATI ARPAN", md: "322" },

//   { sno: 64, category: "C16. MHW Digital Darpan Award", club: "SAJJAPURAM", md: "316" },
//   { sno: 65, category: "C16. MHW Digital Darpan Award", club: "KARAD NAKSHATRA", md: "3234" },
//   { sno: 66, category: "C16. MHW Digital Darpan Award", club: "GAUHATI SOUTH 2", md: "322" },
//   { sno: 67, category: "C16. MHW Digital Darpan Award", club: "DIBRUGARH", md: "322" },
//   { sno: 68, category: "C16. MHW Digital Darpan Award", club: "NINGTHOUKHONG", md: "322" },

//   { sno: 69, category: "C17. MHW Impact Lens Award", club: "BALCO", md: "3233" },
//   { sno: 70, category: "C17. MHW Impact Lens Award", club: "BHOPAL SARVODAYA", md: "3233" },
//   { sno: 71, category: "C17. MHW Impact Lens Award", club: "PARASIA CHANDAMETTA", md: "3233" },
//   { sno: 72, category: "C17. MHW Impact Lens Award", club: "KHANDWA OJAS", md: "3233" },
//   { sno: 73, category: "C17. MHW Impact Lens Award", club: "PARK AVENUE", md: "322" },

//   { sno: 74, category: "C18. MHW Wellness Vahini Award", club: "PANVEL SARGAM", md: "3231" },
//   { sno: 75, category: "C18. MHW Wellness Vahini Award", club: "BHOPAL SARVODAYA", md: "3233" },
//   { sno: 76, category: "C18. MHW Wellness Vahini Award", club: "TRICHUR", md: "318" },
//   { sno: 77, category: "C18. MHW Wellness Vahini Award", club: "KOKRAJHAR GREATER", md: "322" },
//   { sno: 78, category: "C18. MHW Wellness Vahini Award", club: "RAIGANJ UNITY", md: "322" }
// ];


const awardsData = [
  { sno: 1, category: "D1. MHW Star District", club: "District", district: "3232 F1", md: "3232" },
  { sno: 2, category: "D1. MHW Star District", club: "District", district: "3233 G1", md: "3233" },

  { sno: 3, category: "D2. MHW Quantitative Impact Leader", club: "District", district: "317 B", md: "317" },
  { sno: 4, category: "D2. MHW Quantitative Impact Leader", club: "District", district: "3232 F1", md: "3232" },

  { sno: 5, category: "D3. MHW Highest Lion Participation Star District", club: "District", district: "317 B", md: "317" },
  { sno: 6, category: "D3. MHW Highest Lion Participation Star District", club: "District", district: "320 D", md: "320" },

  { sno: 7, category: "D4. MHW Collaboration Star District", club: "District", district: "3234 D1", md: "3234" },
  { sno: 8, category: "D4. MHW Collaboration Star District", club: "District", district: "3232 F1", md: "3232" },

  { sno: 9, category: "C5. MHW Innovation Champion", club: "Jalpaiguri Seva", district: "322 F", md: "322" },
  { sno: 10, category: "C5. MHW Innovation Champion", club: "Alibag", district: "3231 A4", md: "3231" },
  { sno: 11, category: "C5. MHW Innovation Champion", club: "Palakol Femina", district: "316 G", md: "316" },
  { sno: 12, category: "C5. MHW Innovation Champion", club: "Dimapur Japfu", district: "322 D", md: "322" },
  { sno: 13, category: "C5. MHW Innovation Champion", club: "Manipal", district: "317 C", md: "317" },

  { sno: 14, category: "C6. MHW Outreach Hero", club: "Bhopal Sarovar", district: "3233 G2", md: "3233" },
  { sno: 15, category: "C6. MHW Outreach Hero", club: "Parasia Chandametta", district: "3233 C", md: "3233" },
  { sno: 16, category: "C6. MHW Outreach Hero", club: "Masur", district: "3234 D1", md: "3234" },
  { sno: 17, category: "C6. MHW Outreach Hero", club: "Jalpaiguri Seva", district: "322 F", md: "322" },
  { sno: 18, category: "C6. MHW Outreach Hero", club: "Imphal", district: "322 D", md: "322" },

  { sno: 19, category: "C7. MHW Youth Wellness Leader", club: "New Bombay Airoli", district: "3231 A4", md: "3231" },
  { sno: 20, category: "C7. MHW Youth Wellness Leader", club: "Thane Urban", district: "3231 A2", md: "3231" },
  { sno: 21, category: "C7. MHW Youth Wellness Leader", club: "Bhopal Sarovar", district: "3233 G2", md: "3233" },
  { sno: 22, category: "C7. MHW Youth Wellness Leader", club: "Satna", district: "3233 C", md: "3233" },
  { sno: 23, category: "C7. MHW Youth Wellness Leader", club: "Nagaon Greater", district: "322 D", md: "322" },

  { sno: 24, category: "C8. MHW Documentation Excellence Award", club: "Karad Nakshatra", district: "3234 D1", md: "3234" },
  { sno: 25, category: "C8. MHW Documentation Excellence Award", club: "Belman", district: "317 C", md: "317" },
  { sno: 26, category: "C8. MHW Documentation Excellence Award", club: "Bombay Mulund", district: "3231 A2", md: "3231" },
  { sno: 27, category: "C8. MHW Documentation Excellence Award", club: "Hyderabad Capital", district: "320 D", md: "320" },
  { sno: 28, category: "C8. MHW Documentation Excellence Award", club: "Siliguri Greater Femina", district: "322 F", md: "322" },

  { sno: 29, category: "C9. MHW Silver Wellness Award", club: "Parasia-Chandametta", district: "3233 C", md: "3233" },
  { sno: 30, category: "C9. MHW Silver Wellness Award", club: "Belman", district: "317 C", md: "317" },
  { sno: 31, category: "C9. MHW Silver Wellness Award", club: "Bilaspur Pride", district: "3233 C", md: "3233" },
  { sno: 32, category: "C9. MHW Silver Wellness Award", club: "Bhopal Sarovar", district: "3233 G2", md: "3233" },
  { sno: 33, category: "C9. MHW Silver Wellness Award", club: "Satna", district: "3233 C", md: "3233" },

  { sno: 34, category: "C10. MHW Workplace Wellness Star", club: "Hyderabad Jubilee Hills", district: "320 D", md: "320" },
  { sno: 35, category: "C10. MHW Workplace Wellness Star", club: "Satna", district: "3233 C", md: "3233" },
  { sno: 36, category: "C10. MHW Workplace Wellness Star", club: "Bhopal Majestic", district: "3233 G2", md: "3233" },
  { sno: 37, category: "C10. MHW Workplace Wellness Star", club: "Banderdewa", district: "322 D", md: "322" },
  { sno: 38, category: "C10. MHW Workplace Wellness Star", club: "Imphal", district: "322 D", md: "322" },

  { sno: 39, category: "C11. MHW Digital Reach Champion", club: "Karad Nakshatra", district: "3234 D1", md: "3234" },
  { sno: 40, category: "C11. MHW Digital Reach Champion", club: "Parasia-Chandametta", district: "3233 C", md: "3233" },
  { sno: 41, category: "C11. MHW Digital Reach Champion", club: "Siliguri Femina", district: "322 F", md: "322" },
  { sno: 42, category: "C11. MHW Digital Reach Champion", club: "Silchar Ananta", district: "322 G", md: "322" },
  { sno: 43, category: "C11. MHW Digital Reach Champion", club: "Guwahati Arpan", district: "322 G", md: "322" },

  { sno: 44, category: "C12. MHW Little Minds Nurturer", club: "Akkalkot", district: "3234 D1", md: "3234" },
  { sno: 45, category: "C12. MHW Little Minds Nurturer", club: "Panvel Sargam", district: "3231 A4", md: "3231" },
  { sno: 46, category: "C12. MHW Little Minds Nurturer", club: "Satna", district: "3233 C", md: "3233" },
  { sno: 47, category: "C12. MHW Little Minds Nurturer", club: "Hyd. Jubilee Hills", district: "320 D", md: "320" },
  { sno: 48, category: "C12. MHW Little Minds Nurturer", club: "Raiganj Unity", district: "322 H", md: "322" },

  { sno: 49, category: "C13. MWH Tender Hearts Award", club: "Satna", district: "3233 C", md: "3233" },
  { sno: 50, category: "C13. MWH Tender Hearts Award", club: "Karad Nakshatra", district: "3234 D1", md: "3234" },
  { sno: 51, category: "C13. MWH Tender Hearts Award", club: "Jorhat", district: "322 D", md: "322" },
  { sno: 52, category: "C13. MWH Tender Hearts Award", club: "Manipal", district: "317 C", md: "317" },
  { sno: 53, category: "C13. MWH Tender Hearts Award", club: "Raiganj Unity", district: "322 H", md: "322" },

  { sno: 54, category: "C14. MHW Shakti Samman", club: "Bilaspur Pride", district: "3233 C", md: "3233" },
  { sno: 55, category: "C14. MHW Shakti Samman", club: "Imphal Excellence", district: "322 D", md: "322" },
  { sno: 56, category: "C14. MHW Shakti Samman", club: "Pandharpur Dream", district: "3234 D1", md: "3234" },
  { sno: 57, category: "C14. MHW Shakti Samman", club: "Alibag Diamond", district: "3231 A4", md: "3231" },
  { sno: 58, category: "C14. MHW Shakti Samman", club: "Hyderabad Jubilee Hills", district: "320 D", md: "320" },

  { sno: 59, category: "C15. MHW Golden Years Guardian Award", club: "Imphal", district: "322 D", md: "322" },
  { sno: 60, category: "C15. MHW Golden Years Guardian Award", club: "Thane Urban", district: "3231 A2", md: "3231" },
  { sno: 61, category: "C15. MHW Golden Years Guardian Award", club: "Alibag", district: "3231 A4", md: "3231" },
  { sno: 62, category: "C15. MHW Golden Years Guardian Award", club: "Hyderabad Capital", district: "320 D", md: "320" },
  { sno: 63, category: "C15. MHW Golden Years Guardian Award", club: "Guwahati Arpan", district: "322 G", md: "322" },

  { sno: 64, category: "C16. MHW Digital Darpan Award", club: "Sajjapuram", district: "316 G", md: "316" },
  { sno: 65, category: "C16. MHW Digital Darpan Award", club: "Karad Nakshatra", district: "3234 D1", md: "3234" },
  { sno: 66, category: "C16. MHW Digital Darpan Award", club: "Gauhati South 2", district: "322 G", md: "322" },
  { sno: 67, category: "C16. MHW Digital Darpan Award", club: "Dibrugarh", district: "322 D", md: "322" },
  { sno: 68, category: "C16. MHW Digital Darpan Award", club: "Ningthoukhong", district: "322 D", md: "322" },

  { sno: 69, category: "C17. MHW Impact Lens Award", club: "Balco", district: "3233 C", md: "3233" },
  { sno: 70, category: "C17. MHW Impact Lens Award", club: "Bhopal Sarvodaya", district: "3233 G2", md: "3233" },
  { sno: 71, category: "C17. MHW Impact Lens Award", club: "Parasia Chandametta", district: "3233 C", md: "3233" },
  { sno: 72, category: "C17. MHW Impact Lens Award", club: "Khandwa Ojas", district: "3233 G1", md: "3233" },
  { sno: 73, category: "C17. MHW Impact Lens Award", club: "Park Avenue", district: "322 B1", md: "322" },

  { sno: 74, category: "C18. MHW Wellness Vahini Award", club: "Panvel Sargam", district: "3231 A4", md: "3231" },
  { sno: 75, category: "C18. MHW Wellness Vahini Award", club: "Bhopal Sarvodaya", district: "3233 G2", md: "3233" },
  { sno: 76, category: "C18. MHW Wellness Vahini Award", club: "Trichur", district: "318 D", md: "318" },
  { sno: 77, category: "C18. MHW Wellness Vahini Award", club: "Kokrajhar Greater", district: "322 G", md: "322" },
  { sno: 78, category: "C18. MHW Wellness Vahini Award", club: "Raiganj Unity", district: "322 H", md: "322" }
];



const Awards = () => {
     const navigate = useNavigate();
  return (
    <>


    <div className="content-container">

               <button className="back-btn" onClick={() => navigate(-1)}>
        ← Go Back
      </button>
      <h2>MHW Awards Winners List</h2>

      <table className="styled-table">
        <thead>
          <tr>
            <th>S No</th>
            <th>Category</th>
            <th>Club</th>
              <th>District</th>
            <th>MD</th>
          </tr>
        </thead>

        <tbody>
          {awardsData.map((item) => (
            <tr key={item.sno}>
              <td>{item.sno}</td>
              <td>{item.category}</td>
              <td>{item.club}</td>
                <td>{item.district}</td>
              <td>{item.md}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>

    </>
  );
};

export default Awards;